import { FieldModel } from '../extraction-models';
import { Validations } from '@ps-gui/ui';
import { FieldType } from '@ps-gui/shared-utils';

export const OperationenUndProzeduren = {
  operationen_und_prozeduren_ops_code: {
    key: 'operationen_und_prozeduren_ops_code',
    label: { text: 'OPS-Code', genus: 'M' },
    type: FieldType.STRING,
    customTransformValue: (value) => transformOpsCode(value),
    index: 0,
    widthUtilityClass: 'w-2/12',
    validators: [Validations.required()],
  },
  operationen_und_prozeduren_lokalisation: {
    key: 'operationen_und_prozeduren_lokalisation',
    label: { text: 'Lokalisation', genus: 'F' },
    type: FieldType.STRING,
    index: 1,
    widthUtilityClass: 'w-5/12',
    validators: [],
  },
  operationen_und_prozeduren_lokalisation_consolidation: {
    key: 'operationen_und_prozeduren_lokalisation_consolidation',
    inlineConsolidatorForField: 'operationen_und_prozeduren_lokalisation',
    label: { text: 'Lokalisation Konsolidierung', genus: 'F' },
    type: FieldType.DROPDOWN,
    options: ['L', 'R', 'B'],
    index: 1,
    widthUtilityClass: 'w-5/12',
    validators: [],
  },
  operationen_und_prozeduren_leistungsdatum: {
    key: 'operationen_und_prozeduren_leistungsdatum',
    label: { text: 'Leistungsdatum', genus: 'N' },
    type: FieldType.STRING,
    index: 2,
    widthUtilityClass: 'w-5/12',
    validators: [Validations.required(), Validations.date()],
  },
} as const satisfies Record<string, FieldModel>;

const transformOpsCode = (value: string): string => {
  return value.replace(/ /g, '').replace(/,/g, '.');
};
